const THEME_PREFIX = "dtc";
const THEME_CSS_VARIABLE_PREFIX = `--${THEME_PREFIX}-`;
export {
  THEME_CSS_VARIABLE_PREFIX,
  THEME_PREFIX
};
//# sourceMappingURL=types.js.map
